import { render } from "./primaryBtnComponent.vue?vue&type=template&id=149e6636&scoped=true&ts=true"
import script from "./primaryBtnComponent.vue?vue&type=script&lang=ts"
export * from "./primaryBtnComponent.vue?vue&type=script&lang=ts"

import "./primaryBtnComponent.vue?vue&type=style&index=0&id=149e6636&scoped=true&lang=scss"

import exportComponent from "D:\\J\\workspace\\FusionServer\\QUA\\Manitou.FusionServer.Web.DiagPortalFront\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-149e6636"]])

export default __exports__